import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Navbar, Nav, Button} from 'reactstrap';
import { isPDA, MagstimColor, CurrentTheme } from "common";
import { magstim_eventHandler } from "./magstim.js"

import '../html/fontawesome/css/all.min.css'


import MagstimNavBarBrand from './MagstimNavBarBrand'

class MagstimHeaderBar extends React.Component {

	handleClick(value) {
		magstim_eventHandler("click", value);
	}

	render() {
		var close = <></>;
		var navClassName = "ml-auto mr-4";

		if (this.props.ShowClose) {
			close = <Button className="ui-close" onClick={() => this.handleClick("close")}>
				<i className="fas fa-times fa-2x"></i>
			</Button>;	
		}
		else
		{
			if(isPDA()){
				navClassName =  "ml-auto";
			}
		}
		
		return (
			<Wrapper>
				<Navbar expand="lg" className="ui-fillh">
					<MagstimNavBarBrand main_icon={this.props.main_icon} main_title={this.props.main_title} />
					<Nav className={navClassName}>
						{this.props.children}
						{close}
					</Nav>
				</Navbar>
			</Wrapper>
		);
	}
}

const Wrapper = styled.header`
	font-size: 18px;
	height: ${ CurrentTheme().MagstimHeaderBarHeight};
	min-height: ${ CurrentTheme().MagstimHeaderBarHeight};
	color: ${ MagstimColor.MagstimGroupHeaderText };
	background-color: ${ MagstimColor.MagstimCardHeaderBackground };
	vertical-align: middle;
	border: none;
	
	nav.ui-fillh {
		padding-right: 0px;
	}

	button.ui-close {
		padding-left: 28px;
		padding-top: 11px;
		padding-bottom: 11px;
		margin: 0; 
		color: ${ MagstimColor.MagstimGroupHeaderText };
		background-color: ${ MagstimColor.MagstimCardHeaderBackground };
		border: none;
		outline: none;
		box-shadow: none;

		&:hover {
			color: ${ MagstimColor.MagstimPrimaryButton };
			background-color: ${ MagstimColor.MagstimCardHeaderBackground };
		}
		&:active {
			color: ${ MagstimColor.MagstimPrimaryButton } !important;
			background-color: ${ MagstimColor.MagstimCardHeaderBackground } !important;
			border: none;
			outline: none !important;
			box-shadow: none !important;
		}
		&:focus {
			border: none;
			outline: none !important;
			box-shadow: none !important;
		}
	}

`;


MagstimHeaderBar.propTypes = {
	main_title: PropTypes.string,
	main_icon: PropTypes.string,
	ShowClose: PropTypes.bool
};

MagstimHeaderBar.defaultProps = {
	main_title: '',
	main_icon: undefined,
	ShowClose: true
};

export default MagstimHeaderBar;